import { action, createAction, createStandardAction } from 'typesafe-actions'
import { Adzone } from '@chegg-wt/core/constants/adzone'
import { AdLayoutName } from '@chegg-wt/core/types/site'
import { AppRoute, AppRouteName, AppRouteOpts } from '@chegg-wt/core/types/core'
import { ActionTypes } from './constants'
import { SuccessPayload, LocationChangePayload } from './types'

export const createSuccessAction = (constant: string) =>
  createStandardAction(constant)<SuccessPayload>()

export const setAdzone = createAction(ActionTypes.SET_ADZONE, (action) => {
  return (adzone: Adzone) => action({ adzone })
})

export const initSBM = createStandardAction(ActionTypes.SBM_INIT)()

export const setSbmLoaded = (sbmLoaded: boolean) =>
  action(ActionTypes.SET_SBM_LOADED, { sbmLoaded })

export const setAdLayoutName = createAction(ActionTypes.SET_AD_LAYOUT, (action) => {
  return (adLayoutName: AdLayoutName) => action({ adLayoutName })
})

export const navigated = createAction(
  ActionTypes.NAVIGATED,
  (action) => (route: AppRoute, opts: AppRouteOpts = {}) => action({ route, opts })
)
export const flowed = createAction(
  ActionTypes.FLOWED,
  (action) => (nextFlow: AppRouteName) => action({ nextFlow })
)

export const locationChange = createStandardAction(
  ActionTypes.LOCATION_CHANGE
)<LocationChangePayload>()
export const jwtInitialized = createAction(ActionTypes.INITIALIZED, (action) => () =>
  action({})
)

export const setUpdateMessagingFlag = createAction(
  ActionTypes.SET_UPDATE_MESSAGING_FLAG,
  (action) => {
    return (updateMessagingFlag: boolean) => action({ updateMessagingFlag })
  }
)
